/** Session-only profile cache (API-backed). No localStorage. */

const SESSION_STORE_KEY = "ga_profile_session";

export function currentUserKey() {
  try {
    const msisdn = sessionStorage.getItem("refreshToken");
    return msisdn && String(msisdn).trim() ? String(msisdn).trim() : "";
  } catch {
    return "";
  }
}

function readStore() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(SESSION_STORE_KEY) || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  try {
    sessionStorage.setItem(SESSION_STORE_KEY, JSON.stringify(store));
  } catch {
    /* session storage can be unavailable or full */
  }
}

export function getUserProfileRecord() {
  const key = currentUserKey();
  if (!key) return null;
  return readStore()[key] || null;
}

export function updateUserProfileRecord(patch) {
  const key = currentUserKey();
  if (!key) return null;
  const store = readStore();
  store[key] = { ...(store[key] || {}), ...patch };
  writeStore(store);
  return store[key];
}

/** Remove legacy profile keys that used to live in localStorage. */
export function clearLegacyProfileLocalStorage() {
  const keys = [
    "profileByUser",
    "profileForm",
    "profileImage",
    "profileImageChosen",
    "profileAvatarIndex",
    "profileImageName",
    "profileImageSize",
  ];
  keys.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  });
}
